import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'
const ClearSearch: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    width={40}
    height={40}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.25 4.75C14.9167 4.41667 14.4167 4.41667 14.0833 4.75L10 8.83333L5.91667 4.75C5.58333 4.41667 5.08333 4.41667 4.75 4.75C4.41667 5.08333 4.41667 5.58333 4.75 5.91667L8.83333 10L4.75 14.0833C4.41667 14.4167 4.41667 14.9167 4.75 15.25C5.08333 15.5833 5.58333 15.5833 5.91667 15.25L10 11.1667L14.0833 15.25C14.4167 15.5833 14.9167 15.5833 15.25 15.25C15.5833 14.9167 15.5833 14.4167 15.25 14.0833L11.1667 10L15.25 5.91667C15.5833 5.58333 15.5833 5.08333 15.25 4.75Z"
      fill="#002677"
    />
  </Box>
)
export default ClearSearch
